// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"42cf4416","662":"0963adfb"}[chunkId] + ".chunk.css";
};